"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileEmbeddingTypes = void 0;
var ProfileEmbeddingTypes;
(function (ProfileEmbeddingTypes) {
    ProfileEmbeddingTypes["ABOUT_ME"] = "aboutMe";
    ProfileEmbeddingTypes["ADMIN_NOTE"] = "adminNote";
    ProfileEmbeddingTypes["APPLICATION"] = "application";
    ProfileEmbeddingTypes["JOB"] = "job";
    ProfileEmbeddingTypes["PROJECT"] = "project";
    ProfileEmbeddingTypes["BLURB"] = "blurb";
    ProfileEmbeddingTypes["VETTING_FEEDBACK"] = "vettingFeedback";
    ProfileEmbeddingTypes["TIMESHEET_SUMMARY"] = "timesheetSummary";
    ProfileEmbeddingTypes["RESUME"] = "resume";
})(ProfileEmbeddingTypes = exports.ProfileEmbeddingTypes || (exports.ProfileEmbeddingTypes = {}));
//# sourceMappingURL=ProfileEmbeddingTypes.js.map